var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIncomingInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 10.5H49.5V6H45V10.5H27V6H22.5V10.5H13.5C11.04 10.5 9 12.54 9 15V60C9 62.49 11.04 64.5 13.5 64.5H58.5C60.99 64.5 63 62.49 63 60V15C63 12.54 60.99 10.5 58.5 10.5ZM58.5 60H13.5V28.5H58.5V60ZM58.5 24H13.5V15H22.5V19.5H27V15H45V19.5H49.5V15H58.5V24Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 37.5H38.25C37.0074 37.5 36 38.5074 36 39.75V53.25C36 54.4926 37.0074 55.5 38.25 55.5H51.75C52.9926 55.5 54 54.4926 54 53.25V39.75C54 38.5074 52.9926 37.5 51.75 37.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncomingInvitation);
export default __webpack_public_path__ + "static/media/ic-incoming-invitation.c6692023ed9abf10de6e2d6ed4b4e9b5.svg";
export { ForwardRef as ReactComponent };